import React, { useMemo } from 'react';
import {
  Folder,
  isFolderContent,
  isGalleryContent,
  isPanoramaContent,
  isWebStandaloneContent,
  RootFolder,
} from '../services/UploadManagementServiceTypes';
import { ContentGrid } from './ContentGrid';
import { useContentSort } from './contentSort';
import { ContentTable } from './ContentTable';
import { FolderView, PanoramaView, WebStandaloneView, GalleryView } from './ContentViewItem';
import { useUploadContext } from './UploadManagementContext';

export interface ContentListProps {
  currentFolder: Folder | RootFolder;
}

export const ContentList: React.FunctionComponent<ContentListProps> = ({ currentFolder }) => {
  const { dataView, sortField, sortOrder, setSort } = useUploadContext();
  const sortedContent = useContentSort(currentFolder.contents, sortField, sortOrder);
  const items = useMemo(
    () =>
      sortedContent.map((item) => {
        if (isFolderContent(item)) {
          return <FolderView content={item} key={item.guid} />;
        }
        if (isWebStandaloneContent(item)) {
          return <WebStandaloneView content={item} key={item.guid} />;
        }
        if (isPanoramaContent(item)) {
          return <PanoramaView content={item} key={item.guid} />;
        }
        if (isGalleryContent(item)) {
          return <GalleryView content={item} key={item.guid} />;
        }
        return null;
      }),
    [sortedContent],
  );

  if (dataView === 'list') {
    return (
      <ContentTable sortField={sortField} sortOrder={sortOrder} setSort={setSort}>
        {items}
      </ContentTable>
    );
  }

  if (dataView === 'grid') {
    return <ContentGrid>{items}</ContentGrid>;
  }

  return null;
};
